import React, { useState, useEffect, useCallback } from 'react';
import { apiClient } from '../../components/api/ApiClient';
import CompanyEditModal from '../profile/CompanyEditModal';
import MoadianFilesModal from '../profile/MoadianFilesModal';

function CompanyProfile() {
    const [companyData, setCompanyData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showMoadianModal, setShowMoadianModal] = useState(false);

    const fetchCompanyData = useCallback(async () => {
        try {
            const response = await apiClient('/companies/api/');
            if (response.companies && response.companies.length > 0) {
                setCompanyData(response.companies[0]);
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchCompanyData();
    }, [fetchCompanyData]);

    const handleEditSave = () => {
        fetchCompanyData();
    };

    if (loading) return <div className="col-xl-12"><div className="card stretch"><div className="card-body">در حال بارگذاری اطلاعات بنگاه...</div></div></div>;
    if (error) return <div className="col-xl-12"><div className="card stretch"><div className="card-body alert alert-danger">خطا در بارگذاری اطلاعات: {error}</div></div></div>;
    if (!companyData) return <div className="col-xl-12"><div className="card stretch"><div className="card-body alert alert-warning">اطلاعات بنگاهی یافت نشد.</div></div></div>;

    const getPersonType = (type) => {
        switch (type) {
            case 1: return 'حقیقی';
            case 2: return 'حقوقی';
            case 3: return 'مشارکت مدنی';
            case 4: return 'اتباع غیر ایرانی';
            default: return 'نامشخص';
        }
    };

    return (
        <div className="col-xl-12">
            <div className="card stretch">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h5 className="card-title mb-0">مشخصات بنگاه اقتصادی</h5>
                    <div className="d-flex gap-2">
                        <button 
                            className="btn btn-primary btn-sm" 
                            onClick={() => setShowEditModal(true)}
                        >
                            <i className="feather-edit me-1"></i>
                            ویرایش
                        </button>
                        <button 
                            className="btn btn-success btn-sm" 
                            onClick={() => setShowMoadianModal(true)}
                        >
                            <i className="feather-file-text me-1"></i>
                            تولید فایل گواهی
                        </button>
                    </div>
                </div>
                <div className="card-body">
                    <div className="row g-4">
                        <div className="col-lg-4 col-md-6">
                            <label className="form-label fw-bold">نام شرکت/شخص</label>
                            <div className="form-control-plaintext">{companyData.name || '-'}</div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <label className="form-label fw-bold">نوع شخص</label>
                            <div className="form-control-plaintext">{getPersonType(companyData.personType)}</div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <label className="form-label fw-bold">شناسه ملی/کد ملی</label>
                            <div className="form-control-plaintext">{companyData.nationalCode || '-'}</div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <label className="form-label fw-bold">کد اقتصادی</label>
                            <div className="form-control-plaintext">{companyData.economicCode || '-'}</div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <label className="form-label fw-bold">شماره ثبت</label>
                            <div className="form-control-plaintext">{companyData.registrationNum || '-'}</div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <label className="form-label fw-bold">تلفن / همراه</label>
                            <div className="form-control-plaintext">{companyData.phoneNum || companyData.mobileNum || '-'}</div>
                        </div>
                        <div className="col-lg-8 col-md-12">
                            <label className="form-label fw-bold">آدرس</label>
                            <div className="form-control-plaintext">
                                {companyData.province || ''} {companyData.city || ''} {companyData.street || ''} پلاک: {companyData.pelak || ''} کدپستی: {companyData.postalCode || '-'}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <CompanyEditModal
                isVisible={showEditModal}
                onClose={() => setShowEditModal(false)}
                initialData={companyData}
                onSave={handleEditSave}
            />

            <MoadianFilesModal
                isVisible={showMoadianModal}
                onClose={() => setShowMoadianModal(false)}
            />
        </div>
    );
}

export default CompanyProfile;
